// import components
import Checkbox from '@mui/material/Checkbox';

// import hooks
import { useTranslation } from 'react-i18next';

// import styles
import {
  StyledAutocompleteListBox,
  StyledAutocompleteListItem,
  StyledSpanBox
} from './MuiAutocompleteOption.styles';

// import types
import { MuiAutocompleteOptionProps } from './MuiAutocompleteOption.types';

// import utils
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import classNames from 'classnames';
import { v4 as uuidv4 } from 'uuid';

export const optionFontSize = 15;
export const optionPadding = 8;
export const iconMargin = 10;
export const optionHeight = 48;
export const iconWidth = 20 + iconMargin; // ~ 20px (18.56)
export const checkboxWidth = 40;

export default function MuiAutocompleteOption({
  isMulti = false,
  selected,
  label,
  children,
  isInvalid,
  inputValue,
  ...rest
}: MuiAutocompleteOptionProps) {
  const { t } = useTranslation('common');
  if (isInvalid) {
    label += ` (${t('invalid').toLowerCase()})`;
  }

  const matches = match(label, inputValue, { insideWords: true });
  const parts = parse(label, matches).map((p) => ({ ...p, id: uuidv4() }));

  return (
    <StyledAutocompleteListItem
      {...rest}
      className={classNames('MuiAutocomplete-option', 'd-flex', {
        'has-checkbox': isMulti
      })}
    >
      {isMulti && <Checkbox checked={selected} />}
      {children}
      <StyledAutocompleteListBox isInvalid={isInvalid}>
        {parts.map((part) => (
          <StyledSpanBox
            component="span"
            key={part.id}
            isHighlighted={part.highlight}
          >
            {part.text}
          </StyledSpanBox>
        ))}
      </StyledAutocompleteListBox>
    </StyledAutocompleteListItem>
  );
}
